import React from 'react'
import { motion } from "framer-motion";
import Header from '../component/Header'
import introthum from '../introImg.png'
import VisionandMission from '../component/VisionandMission';
import Footer from '../component/Footer';
import Achivment from '../component/Achivment';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import vThum from '../assests/vission.png'
import mThum from '../assests/mission.png'

// import VisionandMission from '..'

export default function About() {
    return (
        <div>
            <Header />
            <section className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-cyan-900  pt-36 pb-10 px-4 sm:px-6 lg:px-8">
                {/* Background Glow */}
                <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-[120px]" />
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/20 blur-[140px] rounded-full" />

                {/* Grid Pattern */}
                <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(255,255,255,.15)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.15)_1px,transparent_1px)] bg-[size:40px_40px]" />

                <div className="max-w-7xl mx-auto relative z-10">
                    {/* Breadcrumb */}
                    <div className="flex items-center  flex-wrap gap-2 text-sm text-white/70 mb-6">Home 
                        <KeyboardArrowRightIcon className="w-4 h-4" />
                        <span className="text-cyan-300">
                            About Us
                        </span>
                    </div>

                    <div className='max-w-6xl'>
                        <h1 className="text-3xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight mb-5">
                            About{" "}
                            <span className="text-dark-gold">
                                Us
                            </span>
                        </h1>

                        {/* Description */}
                        <p className=" text-white/70 text-sm sm:text-base lg:text-lg leading-relaxed mb-8">
                            SBI Capital Markets Limited (SBICAPS) is registered with SEBI as a category I Merchant Banker (Registration No. INM000003531) and a Research Analyst (Registration No. INH000007429).
                        </p>
                        <p className=" text-white/70 text-sm sm:text-base lg:text-lg leading-relaxed mb-8">
                            Incorporated in 1986 as a wholly owned subsidiary of SBI, SBICAPS is one of the oldest investment banks in India, dominating the Indian investment banking landscape for over 35 years. We are a complete solution provider offering diversified corporate advisory and investment banking services, innovative ideas, and unparalleled execution to our clients.
                        </p>

                        <p className=" text-white/70 text-sm sm:text-base lg:text-lg leading-relaxed mb-8">
                            SBICAPS was certified with ISO 9001:2015 – Quality Management System, across all​ its core functional processes in September 2023 by BSI
                        </p>
                    </div>

                    {/* vision mission  */}
                    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                        <div className='p-7 rounded-[0px] text-white'>
                            <img src={mThum} alt='' />
                            <h3 className='text-3xl font-bold pb-4 pt-3 text-dark-gold'>Our Mission</h3>
                            <p className='text-gray-400 leading-8'>To reimagine lending through smart automation and secure infrastructure. We help institutions deliver faster, reliable, and efficient credit experiences with reduced manual effort.</p>
                        </div>
                        <div className='p-7 rounded-[0px] text-white'>
                            <img src={vThum} alt='' />
                            <h3 className='text-3xl font-bold pb-4 text-dark-gold'>Our Vision</h3>
                            <p className='text-gray-400 leading-8'>To create a future where credit is fast, fair, and fully digital. We envision seamless, user-driven lending experiences powered by AI, trusted by users, and accessible anytime, anywhere.</p>
                        </div>
                    </div>
                    {/* end */}


                </div>
            </section>




            <Footer />

        </div>
    )
}
